<template>
  <section class="layoutThemes weflix-admin-layoutThemes">
    <!-- Bloco 1: Escolha do Tema -->
    <div class="themeSelection" v-if="hasReady">
      <TitlePage title="Escolha o Tema" subtitle="Escolha algum dos temas abaixo para personalizar seu site" :hasMargin="true" />
      <div class="themesContainer">
        <div class="col-form-inner col-6 col-md-6 col-lg-6" :class="[typeLayout === 0 ? 'active' : '']" @click="alterarActiveTheme(0)">
          <div class="col-form-inner col-12 col-md-12 col-lg-12">
              <div class="itemTheme">
                  <img src="@/assets/Weflix/theme2.png" alt="Tema 1">
                  <div class="itemTheme-content">
                    <div class="itemTheme-content-header">
                      <h4>Netflix</h4>
                    </div>
                    <div class="itemTheme-content-body">
                      <p>O tema Netflix possui um visual moderno e escuro com tons de preto e cinza, proporcionando menos fadiga visual e destacando o conteúdo de forma elegante.</p>
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="col-form-inner col-6 col-md-6 col-lg-6" :class="[typeLayout === 1 ? 'active' : '']" @click="alterarActiveTheme(1)">
          <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="itemTheme">
              <img src="@/assets/Weflix/theme1.png" alt="Tema 1">
              <div class="itemTheme-content">
                  <div class="itemTheme-content-header">
                    <h4>Light</h4>
                  </div>
                  <div class="itemTheme-content-body">
                    <p>O tema Light possui um design clean e minimalista com tons claros, proporcionando uma experiência visual leve e intuitiva.</p>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bloco 2: Configurações Adicionais -->
    <div class="additionalSettings" v-if="hasReady">
      <div class="titlelayoutThemes">
        <h3>Configurações Adicionais</h3>
        <small>Personalize suas preferências para otimizar a experiência do seu Weflix.</small>
      </div>
      
      <div class="settingsContainer">
        <div class="settingItem">
          <div class="settingHeader">
            <h4>Configurações de Exibição</h4>
            <small>Defina como o conteúdo será mostrado</small>
          </div>
          <div class="displayOptions">
            <div class="optionGroup">
              <div class="optionCardSelect">
                <label for="coverFormatSelect" class="optionLabelSelect">Formato da Capa do Curso</label>
                <select
                  id="coverFormatSelect"
                  v-model="typeImageCoverCourse"
                  class="form-select"
                >
                  <option value="1">Capa Horizontal (1920 x 200px)</option>
                  <option value="2">Capa Vertical (240 x 440px)</option>
                </select>
              </div>
              <div class="optionCardSelect">
                <label for="visibleTitleCourseSelect" class="optionLabelSelect">Exibir títulos dos vídeos</label>
                <select
                  id="visibleTitleCourseSelect"
                  v-model="visibleTitleCourse"
                  class="form-select"
                >
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actionsSave layoutThemesWeflix">
        <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="updateWebsite">Salvar</v-btn>
      </div>
    </div>
  </section>
  <Loader :hasReady="hasReady"/>
</template>

<script>
import websiteApi from '@/utils/Weflix/website';
import { mapState, mapActions } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
  data(){
      return{
          // Todos os campos vindos da API
          id: '',
          nome: '',
          url: '',
          url1: null,
          url2: null,
          title: '',
          description: '',
          keywords: null,
          logo: '',
          color: '',
          favicon: '',
          logoFinal: '',
          faviconFinal: '',
          status: null,
          tagManagerCode: '',
          typeLayout: null,
          javascript: '',
          css: null,
          typeLayoutPortal: null,
          googleAnalyticsCode: '',
          facebookPixelCode: '',
          dateInsert: '',
          email: null,
          phone: null,
          numberCollection: null,
          numberVideo: null,
          timeVideo: null,
          numberSubscription: null,
          about: '',
          termUse: null,
          typeImageCoverCourse: null,
          visibleTitleCourse: null,
          googleAdsCode: '',
          rdsecretClient: '',
          rdclienteId: '',
          rdcode: '',
          rdrefreshToken: '',
          // Controle de carregamento
          hasReady: false,
      }
  },
  computed: {
    ...mapState(['token'])
  },
  components: {
      Loader,
      TitlePage
  },
  methods: {
    ...mapActions(['storeLayoutWebsite']),
    alterarActiveTheme(novoTema) {
      this.typeLayout = novoTema;
    },
    async getWebsite() {
      const response = await websiteApi.getWebsite(this.token);
      // Preenche todos os campos vindos da API
      this.id = response.id;
      this.nome = response.nome;
      this.url = response.url;
      this.url1 = response.url1;
      this.url2 = response.url2;
      this.title = response.title;
      this.description = response.description;
      this.keywords = response.keywords;
      this.logo = response.logo;
      this.color = response.color;
      this.favicon = response.favicon;
      this.logoFinal = response.logoFinal;
      this.faviconFinal = response.faviconFinal;
      this.status = response.status;
      this.tagManagerCode = response.tagManagerCode;
      this.typeLayout = response.typeLayout;
      this.javascript = response.javascript;
      this.css = response.css;
      this.typeLayoutPortal = response.typeLayoutPortal;
      this.googleAnalyticsCode = response.googleAnalyticsCode;
      this.facebookPixelCode = response.facebookPixelCode;
      this.dateInsert = response.dateInsert;
      this.email = response.email;
      this.phone = response.phone;
      this.numberCollection = response.numberCollection;
      this.numberVideo = response.numberVideo;
      this.timeVideo = response.timeVideo;
      this.numberSubscription = response.numberSubscription;
      this.about = response.about;
      this.termUse = response.termUse;
      this.typeImageCoverCourse = response.typeImageCoverCourse;
      this.visibleTitleCourse = response.visibleTitleCourse == 1 ? true : false;
      this.googleAdsCode = response.googleAdsCode;
      this.rdsecretClient = response.rdsecretClient;
      this.rdclienteId = response.rdclienteId;
      this.rdcode = response.rdcode;
      this.rdrefreshToken = response.rdrefreshToken;
      this.hasReady = true;
    },
    async updateWebsite() {
      this.hasReady = false;
      // Monta o payload com todos os campos, mas só atualiza os do componente
      const payload = {
        nome: this.nome,
        url: this.url,
        url1: this.url1,
        url2: this.url2,
        title: this.title,
        description: this.description,
        keywords: this.keywords,
        logo: this.logo,
        color: this.color,
        favicon: this.favicon,
        logoFinal: this.logoFinal,
        faviconFinal: this.faviconFinal,
        status: this.status,
        tagManagerCode: this.tagManagerCode,
        typeLayout: this.typeLayout,
        javascript: this.javascript,
        css: this.css,
        typeLayoutPortal: this.typeLayoutPortal,
        googleAnalyticsCode: this.googleAnalyticsCode,
        facebookPixelCode: this.facebookPixelCode,
        dateInsert: this.dateInsert,
        email: this.email,
        phone: this.phone,
        numberCollection: this.numberCollection,
        numberVideo: this.numberVideo,
        timeVideo: this.timeVideo,
        numberSubscription: this.numberSubscription,
        about: this.about,
        termUse: this.termUse,
        typeImageCoverCourse: this.typeImageCoverCourse,
        visibleTitleCourse: this.visibleTitleCourse ? 1 : 0,
        googleAdsCode: this.googleAdsCode,
        rdsecretClient: this.rdsecretClient,
        rdclienteId: this.rdclienteId,
        rdcode: this.rdcode,
        rdrefreshToken: this.rdrefreshToken
      };
      this.storeLayoutWebsite({ layoutWebsite: payload });
      try {
        await websiteApi.editWebsite(this.token, this.id, payload);
        this.getWebsite();
        this.hasReady = true;
        this.notify('Tema atualizado com sucesso!', 'success');
      } catch (error) {
        this.notify('Erro ao atualizar tema.', 'error');
        console.error('Erro ao atualizar dados do website:', error);
      }
    },
    notify(message, type = "info") {
      toast(message, {
        autoClose: 3000,
        position: 'top-right',
        theme: "light", 
        limit: 1,
        type: type,
        dangerouslyHTMLString: true
      });
    },
  },  
  created() {
      this.getWebsite()
    }
}
</script>

<style scoped>
@import url('./css/themes.css');
.additionalSettings {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  padding: 32px 24px 24px 24px;
  margin-top: 32px;
}

.additionalSettings .titlelayoutThemes {
  margin-bottom: 24px;
}

.additionalSettings .titlelayoutThemes h3 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 4px;
}

.additionalSettings .titlelayoutThemes small {
  color: #888;
  font-size: 0.98rem;
}

.additionalSettings .settingsContainer {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.additionalSettings .settingItem {
  border-radius: 8px;
  padding: 20px 18px;
}

.additionalSettings .settingHeader h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.additionalSettings .settingHeader small {
  color: #888;
  font-size: 0.95rem;
}

.additionalSettings .displayOptions {
  margin-top: 18px;
}

.additionalSettings .optionGroup {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  align-items: center;
}

.additionalSettings .optionCardSelect {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}

.additionalSettings .optionLabelSelect {
  font-size: 1rem;
  color: #444;
  margin-bottom: 2px;
  font-weight: 500;
}

.additionalSettings .form-select {
  min-width: 220px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #222;
  font-size: 1rem;
}

.additionalSettings .form-check {
  display: flex;
  align-items: center;
  margin-top: 0;
}

.additionalSettings .form-check-input[type="checkbox"] {
  width: 38px;
  height: 22px;
  cursor: pointer;
}

.additionalSettings .form-check-label {
  font-size: 1rem;
  color: #444;
  margin-left: 8px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .additionalSettings {
    padding: 18px 8px 16px 8px;
  }
  .additionalSettings .optionGroup {
    flex-direction: column;
    gap: 18px;
    align-items: flex-start;
  }
  .layoutThemes.weflix-admin-layoutThemes {
    padding: 16px;
  }
}

</style>